import React from "react";
import { Link, useNavigate } from "react-router-dom";

interface CaseItem {
  id: number;
  img: string;
  title: string;
  subtitle?: string;
  industry: string;
  tags?: string[];
}

interface CaseProps {
  caseList: CaseItem[];
}

const Case = ({ caseList }: CaseProps) => {
  const navigate = useNavigate();
  function handlecaselist(currentValue: any) {
    window.scrollTo({ top: 0, behavior: "smooth" });
    navigate("/case-detail/" + currentValue.id, {
      state: {
        id: currentValue.id,
      },
    });
  }

  return (
    <>
      {/* <section className='sectionpart2'>
        {
          caseList.map((currentValue:any,index:number) => (
            <div className='box' key={index} onClick={() => {
              handlecaselist(currentValue);
            }}> 
              <div className='inner-container'>
               <div className='img-container'>
                  <img src={currentValue.img} alt={currentValue.tittle} className='case-image' />
                </div> 
                <button className='category-button'>{currentValue.industry}</button>
                <h2 className='tittle'style={{opacity:"1"}} >{currentValue.title}</h2>
                <p className='subtitle'>{currentValue.subtitle}</p> 
                <button className='read-more' >{currentValue.Read}</button>
              </div>
            </div>
          ))
        }
        
      </section > */}

      <div className="sectionpart2">
        {caseList.map((currentValue: any, index: number) => (
          <div className="card" key={index}>
            <img src={currentValue.img} alt="" className="card__image" />

            <div
              className="card__overlay"
              onClick={() => handlecaselist(currentValue)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  handlecaselist(currentValue);
                }
              }}
            />

            <div className="card__content">
              <div className="card__meta">
                <span className="card__industry">{currentValue.industry}</span>
              </div>

              <h3 className="card__title">{currentValue.title}</h3>
              {currentValue.subtitle && (
                <p className="card__subtitle">{currentValue.subtitle}</p>
              )}

              {!!currentValue.tags?.length && (
                <div className="card__tags">
                  {currentValue.tags.map((tag: string, tagIndex: number) => (
                    <span className="tag-pill" key={tagIndex}>
                      {tag}
                    </span>
                  ))}
                </div>
              )}

              <div className="card__footer">
                <Link
                  to={`/case-detail/${currentValue.id}`}
                  state={{ id: currentValue.id }}
                  className="card__link"
                  onClick={(e) => {
                    e.stopPropagation();
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                >
                  Read full story →
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default Case;
